import AdminPage from "./AdminPage";
import CampaignAdminPage from "./CampaignAdminPage";
import InnerCircleAdminPage from "./InnerCircleAdminPage";
import NewsAdminPage from "./NewsAdminPage";
import PrizeAdminPage from "./PrizeAdminPage";
import ProductAdminPage from "./ProductAdminPage";
import RulesAdminPage from "./RulesAdminPage";
import ScoreAdminPage from "./ScoreAdminPage";
import UserAdminPage from "./UserAdminPage";

export default {
  AdminPage,
  CampaignAdminPage,
  InnerCircleAdminPage,
  NewsAdminPage,
  PrizeAdminPage,
  ProductAdminPage,
  RulesAdminPage,
  ScoreAdminPage,
  UserAdminPage
};



// WEBPACK FOOTER //
// ./src/modules/pages/admin/index.js